class PriceFormatter
{

    private static _instance: PriceFormatter;

    formatter: Intl.NumberFormat = new Intl.NumberFormat('ru', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    fractionSeparator: string = ' ';

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    format(price: number): string
    {
        const that = this;

        const parts = this.formatter.formatToParts(price);
        parts.forEach(part => {
            return {
                ...part, 
                value: (part.type === 'group') 
                    ? that.fractionSeparator 
                    : part.value
            };
        });
        return parts.map(v => v.value).join('');
    }

}

export const priceFormatter = PriceFormatter.Instance;